import { ReactNode } from "react";

import { useAccount } from "~/components/account-context/account.context";
import { useAuth } from "~/components/auth-provider";

import { LoadingPage } from "./waiting-component";

export const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const { account, organisation } = useAccount();
  const { isAuthenticated } = useAuth();

  return isAuthenticated && account && organisation ? <>{children}</> : <LoadingPage />;
};
